import React, { useEffect, useState } from 'react';
import { Box, Text, Flex, IconButton, keyframes, VStack, Spacer } from '@chakra-ui/react';
import { X } from 'lucide-react';

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(100px);
  }
`;

// Função para formatar a data
const formatDateTime = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses são baseados em zero
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

const NotificationCard = ({ liveId, id, type, message, createdAt, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  let bgColor;
  let borderColor;
  let textColor = 'white';

  switch (type) {
    case 'venda':
      bgColor = '#F68633';
      borderColor = '#e07a2c';
      break;
    case 'alerta':
      bgColor = 'red.400';
      borderColor = 'red.500';
      break;
    case 'aviso':
      bgColor = 'blue.400';
      borderColor = 'blue.500';
      break;
    default:
      bgColor = 'gray.500';
      borderColor = 'gray.600';
      break;
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 60000);

    return () => clearTimeout(timer);
  }, [liveId]);

  useEffect(() => {
    if (!isVisible) {
      const animationDuration = 300;
      const removeTimer = setTimeout(() => {
        onClose(liveId);
      }, animationDuration);
      return () => clearTimeout(removeTimer);
    }
  }, [isVisible, liveId, onClose]);

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    <Box
      p={3}
      bg={bgColor}
      color={textColor}
      borderRadius="md"
      boxShadow="lg"
      animation={isVisible ? `${slideIn} 0.3s ease-out forwards` : `${slideOut} 0.3s ease-in forwards`}
      mb={3}
      maxW="320px"
      minW="280px"
      border="1px solid"
      borderColor={borderColor}
      position="relative"
      overflow="hidden"
    >
      <Flex justify="space-between" align="center" mb={2}>
        <Text fontWeight="bold" fontSize="sm" textTransform="uppercase">
          {type}
        </Text>
        <IconButton
          icon={<X size={16} />}
          size="xs"
          variant="ghost"
          onClick={handleClose}
          aria-label="Fechar notificação"
          color={textColor}
          _hover={{ bg: 'rgba(255,255,255,0.2)' }}
        />
      </Flex>
      <VStack align="stretch" spacing={2}>
          <Text fontSize="sm">
            {message}
          </Text>
          <Text fontSize="xs" opacity={0.9} textAlign="right">
            {formatDateTime(createdAt)}
          </Text>
      </VStack>
    </Box>
  );
};

export default NotificationCard;